import { render, staticRenderFns } from "./top-content.vue?vue&type=template&id=651a900c&scoped=true&"
import script from "./top-content.vue?vue&type=script&lang=js&"
export * from "./top-content.vue?vue&type=script&lang=js&"
import style0 from "./top-content.vue?vue&type=style&index=0&id=651a900c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a900c",
  null
  
)

export default component.exports